import { RequestService } from 'Utils/Api';
import { logger } from 'Utils/Logger';
import { getDefaultConfig } from 'Utils/Store';

export const verifyAndLinkMemberId = async (memberid) => {
  const { foxApi, accountApiKey } = getDefaultConfig();
  logger.apiRequest('verify member id', {});
  try {
    const result = await RequestService.send({
      url: `${foxApi}/memberverify/va/${memberid}`,
      method: 'POST',
      authenticate: true,
      customHeaders: {
        'x-api-key': accountApiKey,
      },
    });
    logger.apiResponse('verify member id', result);
    return result;
  } catch (error) {
    if (error?.response?.data) {
      logger.apiError('verify member id', error.response.data, error);
      return Promise.reject(error.response.data);
    }
    logger.apiError('verify member id', null, error);
    return Promise.reject(error);
  }
};
